import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "../ui/sonner";

// Un diff se ve como en una revisión de código: líneas agregadas en verde, quitadas en rojo, tramos («@@») en azul.
function diffLineClass(line) {
  if (line.startsWith("+++") || line.startsWith("---")) return "text-zinc-400";
  if (line.startsWith("+")) return "text-emerald-300 bg-emerald-500/10";
  if (line.startsWith("-")) return "text-red-300 bg-red-500/10";
  if (line.startsWith("@@")) return "text-sky-400";
  return "";
}

export function CodeBlockSection({ section, index }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(section.content);
    setCopied(true);
    toast.success("Código copiado");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div data-testid="typed-section-code-block" className="my-3 rounded-lg border border-border overflow-hidden bg-zinc-950">
      <div className="flex items-center justify-between px-3 py-1.5 bg-zinc-900 text-xs text-zinc-400">
        <span className="font-mono">{section.language || "text"}</span>
        <button
          data-testid={`code-copy-button-${index}`}
          onClick={handleCopy}
          className="flex items-center gap-1 hover:text-zinc-100 transition-colors"
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copiado" : "Copiar"}
        </button>
      </div>
      <pre className="px-3 py-2 text-xs md:text-sm text-zinc-100 font-mono overflow-x-auto">
        {section.language === "diff" ? (
          <code data-testid="code-diff">
            {String(section.content || "").split(/\r?\n/).map((line, i) => (
              <span key={i} className={`block ${diffLineClass(line)}`}>{line || " "}</span>
            ))}
          </code>
        ) : (
          <code>{section.content}</code>
        )}
      </pre>
    </div>
  );
}
